const ApiRequest = require('components/api_request.js');

module.exports = class PhotoCheckRequest {
  constructor(photo, imageDetectionPath, checkerRoute, responseAttribute, warningTypeName) {
    this.photo = photo;
    this.imageDetectionPath = imageDetectionPath;
    this.checkerRoute = checkerRoute;
    this.responseAttribute = responseAttribute;
    this.warningTypeName = warningTypeName;
  }

  checkPhoto() {
    return new Promise((resolve, reject) => {
      ApiRequest.get(
        `${this.imageDetectionPath}/v1/detect/${this.checkerRoute}?image_url=${this.encodedImageUrl}`
      ).then(resp => resolve({
        showWarning: !resp[this.responseAttribute],
        warningTypeName: this.warningTypeName,
      }))
      .fail(e => reject(e));
    });
  }

  get encodedImageUrl() {
    const imageUrl = `${this.fullCurrentHost}${this.photo.fullUrl}`;
    return encodeURIComponent(imageUrl);
  }

  get fullCurrentHost() {
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//${window.location.hostname}${port}`;
  }
};



// WEBPACK FOOTER //
// ./javascripts/components/photos/contents/photo_check_request.js